export default class ChangeTheme {
    
    constructor(targetPos, margin) {
        this.pos = targetPos;
        this.margin = margin;
        this.bodyEl = document.querySelector('body');
        this.startTimer();
    }

    startTimer() {
        this.timer = setInterval(()=> this.testScroll(), 250);
    }

    testScroll() {
        if (document.body.scrollTop > this.pos - this.margin) {
            this.bodyEl.className = this.bodyEl.className.indexOf('dark') > -1 ? this.bodyEl.className :  `dark ${this.bodyEl.className}`;
        } else {
            this.bodyEl.className = this.bodyEl.className.replace(/dark\s/g, '');
        }
        
    }
}


// WEBPACK FOOTER //
// ./modules/ChangeTheme/index.js